<template>
  <div class="container">
      <el-row :gutter="20">
          <el-col :span="24" v-for="(item,index) in ylData" :key="index">
              <div class="item">
                  <img  :src="item.url">
                  <span>{{item.dec}}</span>
              </div>
          </el-col>
      </el-row>
  </div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'yl',
    data() {
        return {
            ylData: []
        }
    },
    async created() {
        let res = await axios.get('/api/yl')
        this.ylData = res.data.data
    }
}
</script>

<style lang="scss" scoped>
.item{
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    margin-bottom: 20px;
        background-color: lightgray;
    img{
        border-radius: 20px;
        height: 60vh;
    }span{
        font-size: 40px;
        line-height: 40 px;
        text-align: center;

    }

}
</style>



// WEBPACK FOOTER //
// src/components/yl.vue